<template>
  <div :style="largeScreenContainer">
    <v-container>
      <div class="header">
        <router-link class="d-flex align-center" to="/">
          <Logo />
        </router-link>
        <div class="header-nav">
          <button
            @mouseover="activeLink = 1"
            @mouseleave="activeLink = null"
            to="/"
            class="header-nav-item"
          >
            <span>Products</span>
            <IconCarrot />
            <transition name="slide-fade">
              <div v-if="activeLink === 1" class="header-nav-links">
                <router-link to="/">Product 1</router-link>
                <router-link to="/">Product 2</router-link>
                <router-link to="/">Product 3</router-link>
                <router-link to="/">Product 4</router-link>
                <router-link to="/">Product 5</router-link>
              </div>
            </transition>
          </button>
          <button
            @mouseover="activeLink = 2"
            @mouseleave="activeLink = null"
            to="/"
            class="header-nav-item"
          >
            <span>Solutions</span>
            <IconCarrot />
            <transition name="slide-fade">
              <div v-if="activeLink === 2" class="header-nav-links">
                <router-link to="/">Solutions 1</router-link>
                <router-link to="/">Solutions 2</router-link>
                <router-link to="/">Solutions 3</router-link>
                <router-link to="/">Solutions 4</router-link>
                <router-link to="/">Solutions 5</router-link>
              </div>
            </transition>
          </button>
          <router-link to="/pricing" class="header-nav-item"
            >Pricing</router-link
          >
        </div>
        <v-spacer></v-spacer>
        <div class="header-login">
          Login
        </div>
        <div class="header-input-wrapper">
          <v-text-field
            flat
            outlined
            label="Enter your work email"
            type="text"
            hide-details
            dense
            class="header-input"
          >
            <template v-slot:append>
              <button class="sign-up">Sign up</button>
            </template>
          </v-text-field>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Logo from "@/components/icons/Logo";
import IconCarrot from "@/components/icons/IconCarrot";
export default {
  data() {
    return {
      activeLink: null,
    };
  },
  components: {
    Logo,
    IconCarrot,
  },
};
</script>

<style lang="scss">
.v-text-field--outlined >>> fieldset {
  border-color: red !important;
}
.header {
  padding: 18px 0;
  padding-top: 5px;
  display: flex;
  align-items: center;
  z-index: 9;
  position: relative;

  &-nav {
    margin-left: 54px;
    display: flex;
    align-items: center;

    &-item {
      margin-right: 50px;
      font-size: 16px;
      font-weight: bold;
      color: $default-text-color !important;
      display: flex;
      align-items: center;
      text-decoration: none;
      position: relative;

      span {
        margin-right: 11px;
      }
    }

    &-links {
      position: absolute;
      left: 0;
      top: 100%;
      background: #fff;
      width: max-content;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 8px;
      padding: 5px;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      a {
        padding: 5px 40px;
        padding-left: 20px;
        font-weight: 400;
        text-decoration: none;
        color: $default-text-color !important;
        font-size: 14px;
        &:hover {
          color: $primary-color !important;
        }
      }
    }
  }
  &-login {
    color: $primary-color;
    font-weight: bold;
    font-size: 16px;
    margin-right: 32px;
  }
  &-input {
    background-color: #fff;
    border: none;
    font-size: 14px;
    border: none !important;

    label {
      color: #888 !important;
      font-size: 14px;
    }
    &-wrapper {
      width: 267px;
    }

    .v-text-field--outlined fieldset {
      border: none !important;
    }
  }

  .sign-up {
    background-color: $primary-color;
    border-radius: 3px;
    color: #fff;
    width: 74px;
    height: 32px;
    margin-top: 0;
  }

  .v-input__control {
    border: none !important;

    .v-input__slot {
      padding-right: 3.5px !important;
      border: none !important;
    }
    padding-right: 0 !important;
    .v-input__append-inner {
      margin-top: 4px !important ;
    }
  }
}
</style>
